module.exports = __webpack_public_path__ + "static/media/sublime.4443a3c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sublime.svg
// module id = 115
// module chunks = 0